import * as React from 'react';
import { UilExclamationTriangle } from '@iconscout/react-unicons';

export interface INotesProps {
    note: string;
}

const WarnNotes: React.SFC<INotesProps> = ({ note }) => (
    <div className="note-warn-container">
        <div className="note-warn-title">
            <UilExclamationTriangle size={20} /> Note
        </div>
        <div className="note-warn-content">{note}</div>
    </div>
);

export default WarnNotes;
